import { render } from "./FotoConfirmacao.vue?vue&type=template&id=6c4c192a"
import script from "./FotoConfirmacao.vue?vue&type=script&lang=js"
export * from "./FotoConfirmacao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__